import React, { type FC } from 'react'
import { Grid, Paper, type SxProps, type Theme, Typography } from '@mui/material'

import { BufferType, type TailedTopicMessage } from '../../../../domain'

import { FormattedDateTime } from '../../Internationalization'

import { FormattedBuffer, ReversedTruncatedText, useBufferTypeTranslator } from '../../common'

const wrapperStyle: SxProps<Theme> = {
    mb: 1,
    py: 0.5,
    px: 0,
    '& > * > :first-of-type': { pl: 1 },
    '& > * > :last-of-type': { pr: 1 },
}
const longTextStyle: SxProps<Theme> = { overflowX: 'hidden', pr: 1, display: 'flex', alignItems: 'center' }
const verticalAlignedStyle: SxProps<Theme> = { display: 'flex', alignItems: 'center' }

export const TailLine: FC<TailedTopicMessage> = ({ topic, timestamp, payload, selectedType }) => {
    const translate = useBufferTypeTranslator()

    return (
        <Paper sx={wrapperStyle} variant="outlined">
            <Grid container sx={verticalAlignedStyle}>
                <Grid item xs={2}>
                    <Typography variant="caption">
                        <FormattedDateTime date={timestamp} format="datetime" />
                    </Typography>
                </Grid>
                <Grid item xs={5}>
                    <Typography sx={longTextStyle} title={topic} variant="subtitle1">
                        <ReversedTruncatedText>{topic}</ReversedTruncatedText>
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <FormattedBuffer sx={[selectedType === BufferType.OBJECT ? {} : longTextStyle]} buffer={payload} type={selectedType} />
                </Grid>
                <Grid item xs={1}>
                    {translate(selectedType)}
                </Grid>
            </Grid>
        </Paper>
    )
}
